export default "__VITE_ASSET__blfTvubu__"